import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_DISCOUNT_CODE_AUTHORIZER,
  CLEAR_DISCOUNT_CODE_AUTHORIZERS,
  FLAG_DISCOUNT_CODE_AUTHORIZER_ACTIVITY,
  FLAG_GETTING_DISCOUNT_CODE_AUTHORIZERS,
  GET_DISCOUNT_CODE_AUTHORIZER,
  GET_DISCOUNT_CODE_AUTHORIZERS,
} from '../types';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { DISCOUNT_CODE_AUTHORIZER_ENDPOINT } from '../../config/endpoints';
import { DISCOUNT_CODE_AUTHORIZER_PATH } from '../../config/paths';

const flagGettingDiscountCodeAuthorizers = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DISCOUNT_CODE_AUTHORIZERS,
    payload: flag,
  });

const getDiscountCodeAuthorizers =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDiscountCodeAuthorizers(true));
      const query = tableFilters;
      const url = `${DISCOUNT_CODE_AUTHORIZER_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const pricingProfiles = await response.json();
      dispatch({
        type: GET_DISCOUNT_CODE_AUTHORIZERS,
        payload: pricingProfiles,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingDiscountCodeAuthorizers(false));
    }
  };

const clearDiscountCodeAuthorizers = () => (dispatch) =>
  dispatch({
    type: CLEAR_DISCOUNT_CODE_AUTHORIZERS,
  });

const clearDiscountCodeAuthorizer = () => (dispatch) =>
  dispatch({
    type: CLEAR_DISCOUNT_CODE_AUTHORIZER,
  });

const flagDiscountCodeAuthorizerActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_DISCOUNT_CODE_AUTHORIZER_ACTIVITY,
    payload: flag,
  });

const getDiscountCodeAuthorizer =
  async ({ discountCodeAuthorizerId }) =>
  async (dispatch) => {
    try {
      dispatch(flagDiscountCodeAuthorizerActivity(true));

      const url = `${DISCOUNT_CODE_AUTHORIZER_ENDPOINT}/${discountCodeAuthorizerId}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const discountCodeCategory = await response.json();

      dispatch({
        type: GET_DISCOUNT_CODE_AUTHORIZER,
        payload: discountCodeCategory,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDiscountCodeAuthorizerActivity(false));
    }
  };

const postDiscountCodeAuthorizer =
  async ({ customerId, active }) =>
  async (dispatch) => {
    try {
      dispatch(flagDiscountCodeAuthorizerActivity(true));

      const payload = {
        customerId,
        active,
      };

      const url = DISCOUNT_CODE_AUTHORIZER_ENDPOINT;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const discountCodeAuthorizer = await response.json();

      dispatch(
        push(`${DISCOUNT_CODE_AUTHORIZER_PATH}/${discountCodeAuthorizer.id}`),
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDiscountCodeAuthorizerActivity(false));
    }
  };

const putDiscountCodeAuthorizer =
  async (discountCodeAuthorizerId, { customerId, active }) =>
  async (dispatch) => {
    try {
      dispatch(flagDiscountCodeAuthorizerActivity(true));

      const payload = {
        id: discountCodeAuthorizerId,
        customerId,
        active,
      };

      const url = `${DISCOUNT_CODE_AUTHORIZER_ENDPOINT}/${discountCodeAuthorizerId}`;

      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const discountCodeAuthorizer = await response.json();

      dispatch(
        push(`${DISCOUNT_CODE_AUTHORIZER_PATH}/${discountCodeAuthorizer.id}`),
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagDiscountCodeAuthorizerActivity(false));
    }
  };

export const postDiscountCodeAuthorizerBatch = (items) => async (dispatch) => {
  try {
    dispatch(flagDiscountCodeAuthorizerActivity(true));

    const payload = items;

    const url = `${DISCOUNT_CODE_AUTHORIZER_ENDPOINT}-all`;

    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body: JSON.stringify(payload),
    });

    await isErrorResponse(response, null, dispatch);

    await response.json();
    dispatch(push(`${DISCOUNT_CODE_AUTHORIZER_PATH}`));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagDiscountCodeAuthorizerActivity(false));
  }
};

export {
  getDiscountCodeAuthorizers,
  clearDiscountCodeAuthorizers,
  clearDiscountCodeAuthorizer,
  getDiscountCodeAuthorizer,
  postDiscountCodeAuthorizer,
  putDiscountCodeAuthorizer,
};
